module.exports = __webpack_public_path__ + "9cffd43a700e430d84fbb2c04d277c9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/customer-card-1.png
// module id = 1254
// module chunks = 61